module.exports = __webpack_public_path__ + "static/img/activate4.62e87f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activate4.svg
// module id = 1436
// module chunks = 180